import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const JsonToCsvTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');

  const convert = () => {
    setError('');
    try {
      const data = JSON.parse(input);
      if (!Array.isArray(data) || data.length === 0) {
        setError('Input must be a non-empty JSON array');
        return;
      }

      const headers = [...new Set(data.flatMap(obj => Object.keys(obj)))];
      const csvRows = [headers.join(',')];

      data.forEach(obj => {
        const row = headers.map(header => {
          const val = obj[header] ?? '';
          const str = typeof val === 'object' ? JSON.stringify(val) : String(val);
          return str.includes(',') || str.includes('"') || str.includes('\n') 
            ? `"${str.replace(/"/g, '""')}"` 
            : str;
        });
        csvRows.push(row.join(','));
      });

      setOutput(csvRows.join('\n'));
      toast.success('Converted to CSV!');
    } catch (e) {
      setError('Invalid JSON: ' + e.message);
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('CSV copied!');
  };

  return (
    <div className="space-y-6" data-testid="json-csv-tool">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">JSON Array Input</label>
          <Textarea
            placeholder='[{"name": "John", "age": 30}, {"name": "Jane", "age": 25}]'
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
          {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">CSV Output</label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
            placeholder="CSV output will appear here..."
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={convert} disabled={!input.trim()}>
          <ArrowRightLeft className="w-4 h-4 mr-2" /> Convert to CSV
        </Button>
        <Button onClick={copyOutput} variant="outline" disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy CSV
        </Button>
        <Button onClick={() => { setInput(''); setOutput(''); setError(''); }} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default JsonToCsvTool;
